import {
  CourseWithProgress,
  useGetCourseHearingsQuery,
  useGetCourseLessonsQuery,
  useGetQuizzesQuery,
  useGetUserProjectsQuery,
} from '@teachur/http-client';
import {
  getExamPercent,
  getHearingStatusLabel,
  getHearingStatusTone,
  getProjectStatusLabel,
  getProjectStatusTone,
  SnapshotTone,
} from '../lib/courseSnapshot';

interface CourseSnapshot {
  objectivesCompleted: number;
  objectivesTotal: number;
  examPercent: number;
  projectStatusLabel: string;
  projectStatusTone: SnapshotTone;
  hearingStatusLabel: string;
  hearingStatusTone: SnapshotTone;
}

export const useCourseSnapshot = (course: CourseWithProgress): CourseSnapshot => {
  const { data: lessons } = useGetCourseLessonsQuery(course.id);
  const { data: userProjects } = useGetUserProjectsQuery({ courseId: course.id });
  const { data: quizzes } = useGetQuizzesQuery(
    { courseId: course.id },
    { enabled: !course.isPractical }
  );
  const { data: hearings } = useGetCourseHearingsQuery(
    { courseId: course.id },
    { enabled: !course.isPractical }
  );

  const lessonList = lessons ?? [];

  return {
    objectivesCompleted: lessonList.reduce(
      (sum, lesson) => sum + (lesson.completedObjectives ?? 0),
      0
    ),
    objectivesTotal: lessonList.reduce((sum, lesson) => sum + (lesson.totalObjectives ?? 0), 0),
    examPercent: getExamPercent(quizzes?.data),
    projectStatusLabel: getProjectStatusLabel(userProjects?.data?.[0]?.status),
    projectStatusTone: getProjectStatusTone(userProjects?.data?.[0]?.status),
    hearingStatusLabel: getHearingStatusLabel(hearings?.data?.[0]?.derivedStatus),
    hearingStatusTone: getHearingStatusTone(hearings?.data?.[0]?.derivedStatus),
  };
};
